function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Modal from "../../../eden-platform-modal";
const ContentWrapper = styled.div.withConfig({
  componentId: "sc-1msgda0-0"
})(["width:100vw;@media (min-width:25rem){width:75vw;max-width:839px;min-width:25rem;}"]);

const ContentModal = ({
  active,
  onCloseGesture,
  children,
  ...rest
}) => /*#__PURE__*/React.createElement(Modal, _extends({
  active: active,
  onCloseGesture: onCloseGesture
}, rest), /*#__PURE__*/React.createElement(ContentWrapper, null, children));

ContentModal.propTypes = {
  /** Modal content */
  children: PropTypes.node.isRequired,

  /** Whether modal is open */
  active: PropTypes.bool,

  /** Callback to execute when the modal closes */
  onCloseGesture: PropTypes.func
};
export default ContentModal;